import ScrollReveal from '@/components/base/ScrollReveal';

export default function CTASection() {
  return (
    <section id="contact" className="relative py-24 md:py-32 px-6 md:px-10 lg:px-16 bg-background-50 overflow-hidden scroll-mt-20">
      {/* Background image */}
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20forward%20looking%20technological%20visualization%20with%20ascending%20luminous%20particles%20and%20dynamic%20soft%20light%20streams%20across%20a%20dark%20canvas%2C%20warm%20amber%20and%20golden%20glowing%20accents%20conveying%20progress%20and%20innovation%2C%20ethereal%20optimistic%20atmosphere%2C%20elegant%20artistic%20composition%20with%20smooth%20flowing%20gradients%20and%20subtle%20energy%20waves%2C%20minimal%20sophisticated%20modern%20aesthetic%2C%20very%20dark%20background%20with%20gentle%20ambient%20lighting%2C%20inspiring%20dreamy%20quality%2C%20clean%20design%20suitable%20for%20text%20overlay&width=1600&height=1000&seq=cta-bg-v1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-transparent to-background-50 pointer-events-none"></div>
      {/* Floating orb */}
      <div className="absolute bottom-[10%] right-[-80px] w-[300px] h-[300px] rounded-full bg-primary-500/3 blur-[80px] pointer-events-none orb-float-slow"></div>

      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <ScrollReveal delay={200}>
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-primary-800 leading-[1.12] tracking-tight mb-6">
              Ready to turn your data into{' '}
              <span className="text-accent-500">decisions?</span>
            </h2>
          </ScrollReveal>

          <ScrollReveal delay={500}>
            <a
              href="mailto:contact@datai.asia"
              className="whitespace-nowrap inline-flex items-center justify-center px-8 py-3 rounded-full bg-secondary-200 text-foreground-800 font-semibold text-sm hover:bg-secondary-300 hover:scale-105 transition-all duration-300 cursor-pointer cta-glow"
            >
              Let&apos;s build it
              <i className="ri-arrow-right-line ml-2 text-base cta-arrow"></i>
            </a>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}